import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '热度排行', href: '#ranking' },
  { label: '剧集分类', href: '#index' },
  { label: '精选推荐', href: '#cards' },
  { label: '移动追剧', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[72px] px-4 md:px-6">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 flex-shrink-0"
        >
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-movie-2-line text-background-50 text-lg md:text-xl"></i>
          </div>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-900 whitespace-nowrap">
            天美影视
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick('#contact')}
            className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            商务合作
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => { setMobileOpen(false); handleNavClick('#contact'); }}
              className="mt-2 px-4 py-3 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              商务合作
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}